const autoNgTemplateLoaderTemplate2 = require('./audit-log.html');

import angular from 'angular';

import AuditLogController from './audit-log.controller';
import { AuditLogService } from './audit-log.service';

/*
 * `templateUrl` вынесен на отдельную строку: auto-ngtemplate-loader заменяет путь
 * на require() только когда объявление начинает строку и строковый литерал её
 * завершает. Иначе шаблон не попадает в сборку и страница возвращает 404.
 */
const auditLogView = {
  templateUrl: autoNgTemplateLoaderTemplate2,
  controller: AuditLogController,
};

/**
 * Модуль «Журнал действий»: таблица с фильтрами, поиском, периодом, постраничным просмотром и экспортом CSV.
 */
export default angular.module('shbdeployer.app.audit-log', []).factory('AuditLogService', AuditLogService).component('auditLogView', auditLogView).config(config).name;

/* @ngInject */
function config($stateRegistryProvider) {
  $stateRegistryProvider.register({
    name: 'shbdeployer.auditLog',
    url: '/administration/audit-log',
    views: {
      'content@': {
        component: 'auditLogView',
      },
    },
  });
}
